<template>
  <div>
    <Head title="Create Bot" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/bots">Bots</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <text-input v-model="form.token" :error="form.errors.token" class="pb-8 pr-6 w-full lg:w-1/2" label="Token" />
          <text-input v-model="form.note" :error="form.errors.note" class="pb-8 pr-6 w-full lg:w-1/2" label="Note" />
          <label class="flex items-center select-none" for="active">
            <input id="active" v-model="form.active" class="mr-1" type="checkbox" />
            <span class="text-sm">Active</span>
          </label>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Bot</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        token: null,
        note: null,
        active: false,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/bots')
    },
  },
}
</script>
